import { Controller } from "@hotwired/stimulus"

// Handles inline editing with show/hide toggle
export default class extends Controller {
  static targets = ["display", "edit"]

  toggle(event) {
    event?.preventDefault()
    
    if (this.displayTarget.style.display === 'none') {
      this.showDisplay()
    } else {
      this.showEdit()
    }
  }

  showEdit() {
    this.displayTarget.style.display = 'none'
    this.editTarget.style.display = ''
    
    // Focus the first input
    const input = this.editTarget.querySelector('input, textarea')
    if (input) input.focus()
  }

  showDisplay() {
    this.displayTarget.style.display = ''
    this.editTarget.style.display = 'none'
  }

  cancel(event) {
    event?.preventDefault()
    this.showDisplay()
  }
}
